const paths = {
  // API auth
  LOGIN: '/auth/login',
  LOGOUT: '/auth/logout',
  FORGOT_PASSWORD: '/auth/forgot-password',
  CHANGE_PASSWORD: '/auth/change-password',
  FORCE_CHANGE_PASSWORD: '/auth/force-change',
  REFRESH_TOKEN: '/auth/refresh',

  // API dashboard
  DASHBOARD: '/working-session/all',
  DASHBOARD_CHART: '/working-session/chart',
  DASHBOARD_COUNT: '/working-session/count',

  // API pre registration
  PREREGISTRATION_LIST: '/driver-tmp',
  PRE_REGISTRATION_DETAIL: '/driver-tmp/:id',
  PRE_APPROVE_REGISTRATION_DETAIL: '/driver-tmp/:id/approve',
  PRE_APPROVE_REGISTRATION: '/driver-tmp/approve/bulk',
  CHECK_IMG_QUALITY_TMP: 'driver-tmp/check-quality',
  FIND_TENANT_ID: 'tenant/find-by-path/:path',
  VERIFY_PHONE_DRIVER_TMP: '/driver-tmp/verify/phone/:hashId',

  // API Driver
  DRIVER_MANAGEMENT: '/driver',
  DRIVER_MANAGEMENT_APPROVE: '/driver/:id/approve',
  DRIVER_MANAGEMENT_APPROVE_BULK: '/driver/approve/bulk',
  DRIVER_MANAGEMENT_DETAIL: '/driver/:id',
  DELETE_DRIVER: '/driver/delete-drivers',
  REGISTER_OTP_DRIVER: '/driver/otp-register',
  VERIFY_OTP_DRIVER: '/driver/verify-otp',
  OTP_DRIVER_REGISTER: '/driver',
  CHECK_IMG_QUALITY: '/driver/check-quality',
  DRIVER_APPROVE_ID: '/driver/:id/approve',
  VERIFY_PHONE_DRIVER: '/driver/verify/phone/:hashId',

  // API history driver
  RECEPTION_MANAGEMENT: '/working-session',
  RECEPTION_DAILY_REPORT: '/working-session/history-report',
  RECEPTION_EXPORT: '/working-session/export',
  DAILY_ACCESS_REPORT_EXPORT: '/working-session/export-daily-report',
  FORCE_CHECKOUT: '/working-session/:id/force-checkout',
  DRIVER_STATUS: '/working-session/count-by-status',

  // API device
  DEVICE_LIST: '/device/all',

  // Facility
  FACILITY: '/tenant',
  USER: '/user',
  USER_FORCE_CHANGE_PASSWORD: '/user/:id/force-change-password',

  // Setting
  SETTING: '/setting',
  SETTING_FIND_BY_KEY: 'setting/find-by-key/:key',

  // AppKey
  APP_KEY: '/tenant/api-public',
  APP_KEY_PERMISSION: '/tenant/api-public/:id/permissions',
  APP_KEY_LIST: '/tenant/api-public/list',
  APP_LIST: '/tenant/api/list',

  // SMS
  SNS: '/sns',
  SNS_CONFIG: '/sns/config-sms/get',
  SNS_CONFIG_UPDATE: '/sns/config-sms/update',
  RESEND_VERIFY_PHONE: '/sns/resend-verify-phone',

  // API security box
  SECURITY_BOX_BY_TENANT: '/security-box/search-by-tenant-id',
  ENABLE_BOX: '/box/enable-box',
  OPEN_BOX: '/box/open-box',
  BOXES_BY_SECURITY_BOX: '/security-box/:id/boxes',
  UPDATE_NAME_USECURITY_BOX: '/security-box/:id',

  // Notification
  NOTIFICATON: '/notifications',
  NOTIFICATON_COUNT: '/notifications/unconfirmed-count',
  NOTIFICATON_CONFIRM_ALL: '/notifications/confirm/all',
  NOTIFICATON_CONFIRM: '/notifications/:id/confirm',
};

export default paths;
